<template>
  <button @click="go($event)" class="navButton">
    <img
      v-if="image"
      :class="[imageClass, color]"
      :src="imagePath"
      :style="height"
      :width="width ? width : 20"
      :height="width"
    />
    <div :class="textClass">{{ text }}</div>
  </button>
</template>

<script>
export default {
  props: ['text', 'href', 'image', 'width', 'imageClass', 'textClass', 'color', 'heightAdjust'],
  computed: {
    imagePath() {
      return require(`../../assets/${this.image}`);
    },
    height() {
      return this.heightAdjust ? 'top : ' + this.heightAdjust.toString(10) + 'px' : 'top : 0px';
    },
  },
  methods: {
    go() {
      if (!this.href) {
        this.$emit('go');
        return;
      }

      this.$router.push(this.href).catch(err => {
        if (!this.href === '/settings') {
          this.$log.error(err);
        }
      });
    },
  },
};
</script>

<style scoped>
.navButton {
  outline: none;
  line-height: 19px;
  text-align: left;
  padding: 7px;
  border: none;
  margin: auto;
  cursor: pointer;
  background: rgba(255, 255, 255, 0);
  transition: background-color 300ms;
  z-index: 999;
}

.bordered {
  border-radius: 50%;
  border: 1px rgba(26, 26, 26, 0.15) solid;
  background-color: white;
}

img {
  position: relative;
  float: left;
}

.imageHelp {
  margin-right: 20px;
  width: 45px;
  height: 45px;
  border: 1px solid grey;
  border-radius: 50%;
  padding: 10px;
}

.textHelp {
  display: inherit;
  padding-left: 10px;
}

.grey {
  opacity: 0.4;
}

.white {
  filter: brightness(0) invert(1);
}
</style>
